import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { DocumentTemplatesDetails } from 'src/pages/SettingsPage/components/DocumentTemplatesDetails';
import { InterestRateDetails } from 'src/pages/SettingsPage/components/InterestRateDetails';
import { LandingPageDetails } from 'src/pages/SettingsPage/components/LandingPageDetails';
import { LicenseKeyDetails } from 'src/pages/SettingsPage/components/LicenseKeyDetails';
import { NotificationTemplatesDetails } from 'src/pages/SettingsPage/components/NotificationTemplatesDetails/NotificationTemplatesDetails';
import { SettingsScoringModelPageDetails } from 'src/pages/SettingsPage/components/SettingsScoringModelPageDetails';
import { SettingsListItem } from 'src/pages/SettingsPage/SettingsListItem';
import { SettingsPageHeaderPanel } from 'src/pages/SettingsPage/SettingsPageHeaderPanel';
import { SettingsRoutes } from 'src/stores/SettingsStores/SettingsPageStore/ListApplicationSettings';
import {
    ApplicationSettingItem,
    SettingsPageStore,
} from 'src/stores/SettingsStores/SettingsPageStore/SettingsPageStore';

const getDetailsStore = (pathname: ApplicationSettingItem['settingItemId']) => {
    if (pathname.includes(SettingsRoutes.interestRate)) {
        return <InterestRateDetails />;
    }
    if (pathname.includes(SettingsRoutes.applicationLicense)) {
        return <LicenseKeyDetails />;
    }
    if (pathname.includes(SettingsRoutes.landingPage)) {
        return <LandingPageDetails />;
    }
    if (pathname.includes(SettingsRoutes.scoringModel)) {
        return <SettingsScoringModelPageDetails />;
    }
    if (pathname.includes(SettingsRoutes.documentTemplates)) {
        return <DocumentTemplatesDetails />;
    }
    if (pathname.includes(SettingsRoutes.notificationTemplates)) {
        return <NotificationTemplatesDetails />;
    }
};

export const SettingsPage = observer(() => {
    const { pathname } = useLocation();

    return (
        <MasterDetailsPage
            pageName="settings"
            store={SettingsPageStore}
            asidePanel={<SettingsAsidePanel />}
        >
            {getDetailsStore(pathname as SettingsRoutes)}
        </MasterDetailsPage>
    );
});

const SettingsAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={SettingsPageStore}
            renderItem={(item: ApplicationSettingItem) => {
                return (
                    <List.Item key={item.id}>
                        <SettingsListItem item={item} />
                    </List.Item>
                );
            }}
            header={<SettingsPageHeaderPanel />}
        />
    );
});
